import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const LinkedinIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M22.2 0H1.8C0.8 0 0 0.8 0 1.7V22.3C0 23.2 0.8 24 1.8 24H22.2C23.2 24 24 23.2 24 22.3V1.7C24 0.8 23.2 0 22.2 0ZM7.3 20.1H3.7V9.3H7.3V20.1ZM5.5 7.8H5.4C4.2 7.8 3.4 6.9 3.4 5.9C3.4 4.9 4.3 4 5.5 4C6.7 4 7.5 4.8 7.5 5.9C7.5 6.9 6.7 7.8 5.5 7.8ZM20.3 20.1H16.7V14.3C16.7 12.8 16.2 11.8 14.9 11.8C13.9 11.8 13.3 12.5 13 13.2C12.9 13.4 12.9 13.7 12.9 14V20.1H9.3C9.3 20.1 9.3 10.3 9.3 9.3H12.9V10.8C13.4 10.1 14.3 9 16.2 9C18.6 9 20.3 10.6 20.3 13.9V20.1Z" fill={color} />
  </Svg>
);

LinkedinIcon.displayName = 'LinkedinIcon';
